/* eslint-disable react/prop-types */
import {get} from 'lodash';
import PropTypes from 'prop-types';
import {Button} from 'semantic-ui-react';
import './SelectCoverPageImage.css';

const layouts = {
  large: ({address, agencyLogo, agent, colour, imageUri, cropCoverImage, preparedFor, preparedOn, title, width = 215, height = 303}) => (
    <svg id="large" width={width} height={height} viewBox="0 0 215 303">
      <path stroke="#D8D8D8" strokeWidth="5.234" fill="#FFF" d="M3 3h209.243v296.795H3z"/>
      <text id="title" x="25" y="26" width="165" height="12" fontSize="5.5" fontFamily="Montserrat" fontWeight="600">
        {title}
      </text>
      {agencyLogo && <image id="cover-agencylogo" x="112.5" y="14.5" width="76.5" height="15" xlinkHref={agencyLogo} preserveAspectRatio="xMaxYMin"/>}
      {imageUri && (
        <image x="25" y="35" width="165" height="175"
               xlinkHref={imageUri}
               preserveAspectRatio={cropCoverImage ? 'xMinYMin slice' : undefined}
        />
      )}
      <path id="theme-colour" fill={colour || '#fff'} d="M25 30h165v4.768H25z"/>
      {address && (
        <foreignObject x="25" y="225.5" width="165" height="75">
          <p id="address" style={{
            fontFamily: 'Montserrat', fontSize: 5, fontWeight: 'bold',
            height: 8, width: '100%', display: 'flex', alignItems: 'flex-end',
            margin: 0, padding: 0,
          }}>
            {address}
          </p>
        </foreignObject>
      )}
      {(preparedFor || preparedOn) && (
        <text id="prepared" x="25" y="238.5" width="165" fontSize="3" fontFamily="Montserrat">
          <tspan>Prepared</tspan>
          {preparedFor && <tspan> for <tspan fontWeight="bold">{preparedFor}</tspan></tspan>}
          {preparedOn && <tspan> on <tspan fontWeight="bold">{preparedOn}</tspan></tspan>}
        </text>
      )}
      <path fill="#C8CACB" d="M25 242h165v.25H25Z"/>
      {get(agent, 'photo') && <image id="agent-photo" x="155" y="245" width="35" height="35" xlinkHref={get(agent, 'photo')} preserveAspectRatio="xMinYMin"/>}
      <g transform={get(agent, 'photo') ? '' : 'translate(40 0)'}>
        {get(agent, 'name') && <text className="cover-agent name" x="150" y="250" fontFamily="Montserrat" fontSize="4" fontWeight="bold" textAnchor="end">{agent.name}</text>}
        {get(agent, 'tradeName') && <text className="cover-agent trade-name" x="150" y="254" fontFamily="Montserrat" fontSize="3" textAnchor="end">{agent.tradeName}</text>}
        {get(agent, 'address1') && <text className="cover-agent address1" x="150" y="260.5" fontFamily="Montserrat" fontSize="3" textAnchor="end">{agent.address1}</text>}
        {get(agent, 'address2') && <text className="cover-agent address2" x="150" y="264.5" fontFamily="Montserrat" fontSize="3" textAnchor="end">{agent.address2}</text>}
        {get(agent, 'mobilePhone') && <text className="cover-agent mobile-phone" x="150" y="271" fontFamily="Montserrat" fontSize="3" textAnchor="end">m: {agent.mobilePhone}</text>}
        {get(agent, 'workPhone') && <text className="cover-agent work-phone" x="150" y="275" fontFamily="Montserrat" fontSize="3" textAnchor="end">w: {agent.workPhone}</text>}
        {get(agent, 'workEmail') && <text className="cover-agent work-email" x="150" y="279" fontFamily="Montserrat" fontSize="3" textAnchor="end">{agent.workEmail}</text>}
      </g>
    </svg>
  ),
  half: ({address, agencyLogo, agent, colour, imageUri, preparedFor, preparedOn, title, width = 215, height = 303}) => (
    <svg id="half" width={width} height={height} viewBox="0 0 215 303">
      <path stroke="#D8D8D8" strokeWidth="5.234" fill="#FFF" d="M3 3h209.243v296.795H3z"/>
      {agencyLogo && <image id="cover-agencylogo" x="90" y="15.5" width="100" height="15" xlinkHref={agencyLogo} preserveAspectRatio="xMaxYMin"/>}
      {imageUri && <image id="cover-photo" x="25" y="107" width="165" height="110" xlinkHref={imageUri}/>}
      <path id="theme-colour" fill={colour || '#fff'} d="M25 102h165v5H25z"/>
      <foreignObject x="25" y="52" width="177" height="44">
        <p id="title" style={{fontSize: 16, fontFamily: 'Montserrat', fontWeight: 600, lineHeight: 1.2}}>{title}</p>
      </foreignObject>
      {(preparedFor || preparedOn) && (
        <text id="prepared" x="25" y="96" width="177" fontSize="4" fontFamily="Montserrat">
          <tspan>Prepared</tspan>
          {preparedFor && <tspan> for <tspan fontWeight="bold">{preparedFor}</tspan></tspan>}
          {preparedOn && <tspan> on <tspan fontWeight="bold">{preparedOn}</tspan></tspan>}
        </text>
      )}
      {address && (
        <foreignObject x="25" y="224" width="165" height="75">
          <p id="address" style={{
            fontFamily: 'Montserrat', fontSize: 6, fontWeight: 'bold',
            height: 16, width: '100%', display: 'flex', alignItems: 'flex-end',
          }}>
            {address}
          </p>
        </foreignObject>
      )}
      <path fill="#C8CACB" d="M25 241h165v.25H20Z"/>
      {get(agent, 'photo') && <image id="agent-photo" x="25" y="245" width="35" height="35" xlinkHref={get(agent, 'photo')} preserveAspectRatio="xMinYMin"/>}
      <g transform={get(agent, 'photo') ? 'translate(60 0)' : 'translate(190 0)'} textAnchor={get(agent, 'photo') ? 'start' : 'end'}>
        {get(agent, 'name') && <text className="cover-agent name" x="0" y="250" fontFamily="Montserrat" fontSize="4" fontWeight="bold">{agent.name}</text>}
        {get(agent, 'tradeName') && <text className="cover-agent trade-name" x="0" y="254" fontFamily="Montserrat" fontSize="3">{agent.tradeName}</text>}
        {get(agent, 'address1') && <text className="cover-agent address1" x="0" y="260.5" fontFamily="Montserrat" fontSize="3">{agent.address1}</text>}
        {get(agent, 'address2') && <text className="cover-agent address2" x="0" y="264.5" fontFamily="Montserrat" fontSize="3">{agent.address2}</text>}
        {get(agent, 'mobilePhone') && <text className="cover-agent mobile-phone" x="0" y="271" fontFamily="Montserrat" fontSize="3">m: {agent.mobilePhone}</text>}
        {get(agent, 'workPhone') && <text className="cover-agent work-phone" x="0" y="275" fontFamily="Montserrat" fontSize="3">w: {agent.workPhone}</text>}
        {get(agent, 'workEmail') && <text className="cover-agent work-email" x="0" y="279" fontFamily="Montserrat" fontSize="3">{agent.workEmail}</text>}
      </g>
    </svg>
  ),
};

const CoverPageLayout = ({address, agencyLogo, agent, imageUri, cropCoverImage, colour, name = 'half', showButton = true, onClick, width, height, preparedFor, preparedOn, title}) => {
  const fixedImageUri = imageUri && imageUri.replace(/\/resize;.*/, '/resize;m=limit;w=352;h=236;logo=false;date=false');

  return (
    <div style={showButton ? {alignItems: 'center', display: 'flex', flexDirection: 'column'} : null}>
      {layouts[name]({address, agencyLogo, agent, imageUri: fixedImageUri, cropCoverImage, colour, width, height, preparedFor, preparedOn, title})}
      {showButton && <Button secondary onClick={onClick} style={{marginTop: 16}}>Select Layout & Image</Button>}
    </div>
  );
};

CoverPageLayout.propTypes = {
  address: PropTypes.string,
  agencyLogo: PropTypes.string,
  agent: PropTypes.shape({
    name: PropTypes.string,
    photo: PropTypes.string,
    tradeName: PropTypes.string,
    address1: PropTypes.string,
    address2: PropTypes.string,
    workPhone: PropTypes.string,
    mobilePhone: PropTypes.string,
    workEmail: PropTypes.string,
  }),
  name: PropTypes.oneOf(['half', 'large']),
  imageUri: PropTypes.string,
  cropCoverImage: PropTypes.bool.isRequired,
  colour: PropTypes.string,
  showButton: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
  preparedFor: PropTypes.string,
  preparedOn: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
};

export default CoverPageLayout;
